// @mui
import { GetVisitByIdVisitTypeEnum } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';

import Label from '../label';
// ----------------------------------------------------------------------

interface ServiceBadgeProps {
  serviceName?: string;
  duration?: number;
  price?: number;
  visitType?: GetVisitByIdVisitTypeEnum;
  showPrice?: boolean;
}

export default function ServiceBadge({
  serviceName,
  duration,
  price,
  visitType,
  showPrice,
}: ServiceBadgeProps) {
  if (!serviceName) {
    return null;
  }

  const priceText =
    showPrice && price !== undefined && price > 0 ? translateKey("hardcoded.priceComma", { price }) : '';
  const durationText = duration ? `${duration} min` : '';
  const label = `${serviceName} (${durationText}${priceText})`;

  // Match the color scheme of VisitTypeBadge
  const getColor = () => {
    switch (visitType) {
      case GetVisitByIdVisitTypeEnum.Onsite:
        return 'primary';
      case GetVisitByIdVisitTypeEnum.Video:
        return 'warning';
      case GetVisitByIdVisitTypeEnum.Chat:
        return 'error';
      case GetVisitByIdVisitTypeEnum.Mobile:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Label
      variant="soft"
      color={getColor()}
      sx={{
        textTransform: 'none',
        width: 'fit-content',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        maxWidth: '100%',
      }}
    >
      {label}
    </Label>
  );
}
